import { useFeatureContext } from "@omni/ui/components/Product/Feature/KeyFeatures/components/feature/context/feature.context";
import { cn } from "@omni/utils/styles";

import { FeatureValue } from "@/components/Product/Feature/FeatureValue/featureValue";

type Props = {
    className?: string;
};

export const Value = ({ className }: Props) => {
    const { feature } = useFeatureContext();

    const formattedValues = feature.featureValues.map(
        (featureValue) => featureValue.formattedValue || ""
    );

    const unitName = feature.unit?.name;

    return (
        <span className={cn(className)}>
            <FeatureValue
                formattedValues={formattedValues}
                unitName={unitName}
            />
        </span>
    );
};
